import { GetterTree } from 'vuex';
import { UsersState, UserPaginator } from './types';
import { RootState } from '@/types';

export const getters: GetterTree<UsersState, RootState> = {
    users(state): UserPaginator | undefined {
        const users  = state.data || undefined;
        return users;
    },
};
